import React from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { BillingTransactionStatus } from "@/types/billing-transactions";
import { BillingTransactionStatusBadge } from "./BillingTransactionStatusBadge";

interface BillingTransactionStatusSelectProps {
  value: BillingTransactionStatus;
  onValueChange: (status: BillingTransactionStatus) => void;
}

const UPDATE_STATUS_OPTIONS = [
  BillingTransactionStatus.SUCCEEDED,
  BillingTransactionStatus.CANCELED,
  BillingTransactionStatus.FAILED,
  BillingTransactionStatus.PENDING,
  BillingTransactionStatus.REFUNDED,
  BillingTransactionStatus.PARTIALLY_REFUNDED,
] as const;

function isBillingTransactionStatus(
  value: string,
): value is BillingTransactionStatus {
  return Object.values(BillingTransactionStatus).some(
    (status) => status === value,
  );
}

export const BillingTransactionStatusSelect: React.FC<
  BillingTransactionStatusSelectProps
> = ({ value, onValueChange }) => {
  const handleValueChange = (nextValue: string) => {
    if (isBillingTransactionStatus(nextValue)) {
      onValueChange(nextValue);
    }
  };

  return (
    <div onClick={(event) => event.stopPropagation()}>
      <Select value={value} onValueChange={handleValueChange}>
        <SelectTrigger className="mx-auto min-w-36 justify-between">
          <BillingTransactionStatusBadge status={value} />
        </SelectTrigger>
        <SelectContent align="center">
          <SelectGroup>
            {UPDATE_STATUS_OPTIONS.map((status) => (
              <SelectItem key={status} value={status}>
                <BillingTransactionStatusBadge status={status} />
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};
